import Main from './Main'
import Lista from './components/SituacaoApreensaoLista'
import Novo from './components/NovaSituacaoApreensao'

export default [
  {
    path: 'situacao-apreensao',
    name: 'policiacivil.processo.situacao-apreensao',
    component: Main,
    redirect: { name: 'policiacivil.processo.situacao-apreensao.list' },
    children: [
      {
        path: '/',
        name: 'policiacivil.processo.situacao-apreensao.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'policiacivil.processo.situacao-apreensao.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'policiacivil.processo.situacao-apreensao.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/processo/situacao-apreensao/routes.js